import { render } from "./DoughChart.vue?vue&type=template&id=a073b816"
import script from "./DoughChart.vue?vue&type=script&lang=js"
export * from "./DoughChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__